/**
 * VendorPickerMessage — the live affordance is rendered by Chat's
 * pendingSidecarAction overlay (a button panel that replaces the
 * PromptInput). This chat bubble renders the question text only so Vera's
 * narration stays readable; the "Open vendor picker" button lives above
 * the chat input. See RFC-154 §0 / input-consolidation phase 3.
 */
import { useMemo } from 'react'

interface VendorPickerToolData {
  question: string
  categories: Record<string, string[]>
  vendorLogos?: Record<string, string>
  preSelected?: string[]
  scope?: string
}

function parseToolData(part: any): VendorPickerToolData | null {
  try {
    if (part.output != null) {
      return typeof part.output === 'string' ? JSON.parse(part.output) : part.output
    }
    if (part.toolInvocation?.result) {
      return typeof part.toolInvocation.result === 'string'
        ? JSON.parse(part.toolInvocation.result)
        : part.toolInvocation.result
    }
    if (part.input) {
      return typeof part.input === 'string' ? JSON.parse(part.input) : part.input
    }
    return part.toolInvocation?.args ?? null
  } catch {
    return null
  }
}

export function VendorPickerMessage({ part }: { part: any }) {
  const data = useMemo(() => parseToolData(part), [part])
  if (!data?.question) return null
  return (
    <div className='w-full'>
      <p className='mb-0 text-sm font-medium'>{data.question}</p>
    </div>
  )
}
